// Ported from courtsapp.com's tournament card. Every number here — the 14px
// body padding, the 7px row gap, the 45px pill, the rgba mint — was read out of
// the site's own style sheet, not matched by eye. The card shell (width, radius,
// shadow, hover, entry animation) still comes from .lk-product-card; only the
// site-specific interior is redefined.
export const TOURNAMENT_CARD_CSS = /* css */ `
  /* Wider than the 240px product card: this one carries three icon rows, a
     price block and a full-width pill, and at 240 the venue and location lines
     were ellipsing on ordinary names. 280 still leaves the next card peeking
     past the 340px panel edge, which is what tells anyone the row scrolls. */
  .lk-tournament-card { width: 280px; }
  .lk-tournament-banner {
    position: relative;
    height: 160px;
    flex-shrink: 0;
    background: #f8f8f1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /* Event banners are wide promo art, letterboxed on the site's cream rather
     than cropped — a QR code or a logo loses its meaning under a cover crop. */
  .lk-tournament-banner-image {
    width: 100%;
    height: 100%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .lk-tournament-badge {
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.12px;
  }
  .lk-tournament-badge--open {
    background: #26d197;
    color: #061934;
  }
  .lk-tournament-badge--closing {
    background: #54766e;
    color: #fff;
  }
  .lk-tournament-body {
    flex: 1;
    padding: 14px 14px 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 14px;
  }
  .lk-tournament-info { display: flex; flex-direction: column; gap: 7px; }
  .lk-tournament-title-block { display: flex; flex-direction: column; gap: 4px; }
  .lk-tournament-eyebrow {
    font-size: 12px;
    font-weight: 600;
    line-height: 12px;
    letter-spacing: 0.36px;
    color: #8c95a2;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /* Always two lines tall, even for a one-line name. Cards in a row stretch to
     the tallest, and the body pins its footer to the bottom — so a short title
     next to a wrapping one opened a void above the price. Reserving both lines
     makes the cards the same height, which leaves space-between nothing to
     distribute. Anything past two lines ellipses instead of growing the card. */
  .lk-tournament-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: #061934;
    min-height: 48px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .lk-tournament-rows { display: flex; flex-direction: column; gap: 7px; }
  .lk-tournament-row {
    display: flex;
    align-items: center;
    gap: 7px;
    min-width: 0;
  }
  .lk-tournament-row svg { flex-shrink: 0; }
  .lk-tournament-row-text {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.13px;
    color: #586577;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .lk-tournament-footer { display: flex; flex-direction: column; gap: 14px; }
  .lk-tournament-price-block {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }
  .lk-tournament-price-tag {
    background: rgba(38, 209, 151, 0.5);
    border-radius: 4px;
    padding: 4px;
    font-size: 12px;
    font-weight: 600;
    line-height: 12px;
    letter-spacing: -0.12px;
    color: #0a4628;
  }
  .lk-tournament-price {
    font-size: 18px;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: -0.36px;
    color: #061934;
  }
  .lk-tournament-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 45px;
    border-radius: 9999px;
    padding: 0 16px;
    background: #0a3228;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: -0.168px;
  }
`;
